import { render, staticRenderFns } from "./JenisRS.vue?vue&type=template&id=5fc65466"
import script from "./JenisRS.vue?vue&type=script&lang=js"
export * from "./JenisRS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports